import React, { FC, useState } from 'react'
import { IonFooter, IonContent, IonPage, useIonViewWillEnter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { useHistoryNew, localStore } from '@utils'
import { MallCheckoutPayController, MallRestoreOrderController } from '@ctrls/mallController'
import { cartMobx, restaurantConfig } from 'mobx/mall'
import { orderMobx } from 'restaurant'
import './index.scss'

interface IProps extends RouteComponentProps {}

const Payfail: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { id } = match.params as any
  const [reason, setReason] = useState('')
  /** 判断从哪来 type === mall 商城订单 */
  const [type, setType] = useState('')
  const [fromOrderList, setFromOrderList] = useState(false)

  const handleCancel = () => {
    localStore.remove(MallRestoreOrderController.localKey())
    cartMobx.reset()
    orderMobx.cancel()
    history.replace('/mall')
  }

  useIonViewWillEnter(() => {
    const state: any = history.location?.state
    setFromOrderList(history.getPrevState() === '/orders')
    setType(state && state.type || '')
    setReason(state && state.reason ? state.reason : fromOrderList ? i18n.t('pay.payUnfinished') : i18n.t('pay.failedMessage'))
    if (orderMobx.order.ordersId) {
      MallCheckoutPayController.resume(orderMobx.order.ordersId)
    } else {
      // if (id) {
      //   store.set(.localKey(), id)
      // }
    }
  })
  return (
    <IonPage className='pay-fail-page'>
      <IonContent>
        <i className='iconfont icon-warning-circle' />
        <h4>{i18n.t('pageName.payfail')}</h4>
        <h6>{reason}</h6>
      </IonContent>
      <IonFooter>
        <div className='handle-btn'>
          {/* <div
            className='repay' onClick={() => {
              cartMobx.setCaveResetCartToCart()
              setTimeout(() => {
                history.replace('/mcheckout')
              }, 100)
            }}
          >{i18n.t('payfail.repay')}
          </div> */}
          <div
            className='reproduct' onClick={handleCancel}
          >{i18n.t('order.cancelOrder')}
          </div>
        </div>
      </IonFooter>
    </IonPage>
  )
}
export default Payfail
